import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { userInfoLinkedBusinessAccountsCacheKey } from "./constants";
import type { PatchUserInfoLinkedBusinessAccountRoleParams } from "./types";

export const patchUserInfoLinkedBusinessAccountRole = reactQueryMutationAdapter(
  [userInfoLinkedBusinessAccountsCacheKey],
  ({ userId, ...body }: PatchUserInfoLinkedBusinessAccountRoleParams): Promise<void> => {
    return fetch(
      `/apps/user_info_linked_business_accounts/${encodeURIComponent(userId)}`,
      "PATCH",
      body,
      undefined,
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
